'use strict';

// Use application configuration module to register a new module
ApplicationConfiguration.registerFeatureModule('stores', 'stores.store-search');